/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import CarForm from './CarForm';
import { carInitialFormData } from './car.schema';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Main } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { getCarCategoriesFeature } from '../../../redux/car/actionCreator';

const CreateCar = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // const { colorsData, carColorLoading } = useSelector(state => ({
  //   colorsData: state.carColor.colors,
  //   carColorLoading: state.carColor.loading,
  // }));
  const { userType, feature_categories } = useSelector(state => {
    return {
      carLoading: state.car.loading,
      userType: state.auth.user.role.name,
      feature_categories: state.car.feature_categories,
    };
  });

  const [formData, setFormData] = useState({ ...carInitialFormData });

  // useEffect(() => {
  //   getAllColors(dispatch);
  // }, []);

  useEffect(() => {
    if (feature_categories.length === 0) dispatch(getCarCategoriesFeature());
  }, []);

  return (
    <>
      <PageHeader
        ghost
        title="Add New Car"
        buttons={[
          <Button
            key="1"
            style={{ backgroundColor: 'grey', color: '#fff' }}
            size="default"
            onClick={() => history.push(`/${userType}/cars`)}
          >
            <FeatherIcon icon="chevron-left" size={16} /> Back to List
          </Button>,
        ]}
      />
      <Main>
        <Cards headless>
          <div className="body-type-modal">
            <CarForm formData={formData} setFormData={setFormData} />
          </div>
        </Cards>
      </Main>
    </>
  );
};

export default CreateCar;
